const states = {
    team_member_setting_details: {
        team_members: [],
        current_member_permissions: {},
        loaders: {
            team_members_loading: false,
            team_members_loaded: false,
            new_member_adding: false,
            user_permission_loading: false,
            user_permission_loaded: false,
            user_permission_updating: false,
        }
    }
};

export default states;


// WEBPACK FOOTER //
// ./src/data/redux/team_member_setting_details/states.js